import { useEffect, useState } from 'react';
import { Icon } from '../components/Icon.jsx';
import { getAiModels } from '../../api/services/aiService';
import { AiUsageMini, useAiUsage } from '../../components/ai/AiUsage';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';

export function ModelPanel({ bot, updateBot, notify }) {
  const { can } = useWorkspace();
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(bot.model);
  const { usage } = useAiUsage({ enabled: can('billing:read'), pollMs: 30000 });

  useEffect(() => { getAiModels().then(setCatalog).catch((e) => setError(e.message || 'Could not load models.')); }, []);

  function save() {
    if (!selected) { setError('Choose a model to continue'); return; }
    setError('');
    updateBot({ model: selected });
    notify('success', 'Model updated');
  }

  return (
    <div>
      <div className="panel-header">
        <h1>Model &amp; AI</h1>
        <p>Choose the AI model that writes this bot’s replies. ChatBizz provides the AI, so there is no OpenAI key to manage.</p>
      </div>
      <div className="card">
        {!catalog && !error && <p className="muted">Loading models…</p>}
        {error && <div className="error-text" role="alert"><Icon.alert s={12} /> {error}</div>}
        {catalog && (
          <div role="radiogroup" aria-label="AI model" className="model-list">
            {catalog.models.map((m) => (
              <label key={m.id} className={'model-card' + (selected === m.id ? ' selected' : '') + (m.available ? '' : ' locked')}>
                <input type="radio" name="bot-model" value={m.id} checked={selected === m.id} disabled={!m.available} onChange={() => setSelected(m.id)} />
                <span className="model-body">
                  <span className="model-name">{m.label}{m.id === catalog.defaultModel && <em> · recommended</em>}</span>
                  <span className="model-desc">{m.description}</span>
                </span>
                {!m.available && <span className="model-lock">Available on {m.minPlan}</span>}
              </label>
            ))}
          </div>
        )}
        {catalog && <p className="muted small mt-2">Your workspace is on the <strong>{catalog.plan}</strong> plan.</p>}
        <AiUsageMini usage={usage} />
        <div className="actions-row">
          <button className="btn-primary" disabled={!catalog || selected === bot.model} onClick={save}>Save changes</button>
        </div>
      </div>
    </div>
  );
}
